export default "__VITE_ASSET__mSVC6$R7__"